import React from "react";

export default function Spinner({className = ""}) {
  return (
    <span
      className={`${className} spinner-border spinner-border-sm`}
      role="status"
      aria-label="spinner"
      aria-hidden="true"></span>
  );
}
